import { ArrowUpRight, Frame, Hand, Image, ListTodo, MessageSquare, MousePointer2, Shapes, Spline, SquareDashed, StickyNote, Table, Type, type LucideIcon } from 'lucide-react';
import type { ToolId } from '@os/engine';

/** One icon family for the whole app (lucide: 24 px grid, round caps), drawn at one size and one stroke. */
export const TOOL_ICONS: Record<ToolId, LucideIcon> = {
  select: MousePointer2,
  hand: Hand,
  text: Type,
  sticky: StickyNote,
  shape: Shapes,
  arrow: ArrowUpRight,
  connector: Spline,
  section: SquareDashed,
  frame: Frame,
  table: Table,
  tasklist: ListTodo,
  image: Image,
  comment: MessageSquare,
};

export const ICON_STROKE = 1.75;

export function Icon({ icon: Glyph, size = 20, className }: { icon: LucideIcon; size?: number; className?: string }) {
  return <Glyph size={size} strokeWidth={ICON_STROKE} aria-hidden="true" className={className} />;
}
